import React from "react";
import { Navbar, Nav } from "react-bootstrap";
// import btnArrow from "./../../images/ArrowRightWhite.svg";
import { Link } from "react-router-dom";
import { UserContext } from "../../lib/context";
import LoadingSpinner from "../LoadingSpinner";

class TabMonoMK2MorphCard extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
    this.items = [];
    for (var i = 0; i < this.props.tabData.tabs.length; i++) {
      if (i !== this.props.tabData.tabs.length - 1) {
        this.items.push(
          <Nav.Link
            key={i}
            href={this.props.tabData.tabs[i].link}
            className={`tabTxtMono ${
              this.props.currentSection === i ? "color" : ""
            } `}
          >
            {this.props.tabData.tabs[i].name}
          </Nav.Link>
        );
      } else {
        this.items.push(
          <Link
            key={i}
            className={`tabTxtMono ${
              this.props.currentSection === i ? "color" : ""
            } `}
            to={`manual`}
          >
            {this.props.tabData.tabs[i].name}
          </Link>
        );
      }
    }
  }

  orderNow = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    console.log(this.context.psu);
    this.redirectToCheckout = true;

    try {
      // Use Cart API with discount code applied via GraphQL
      const variantId = (this.context.psu === 0) ? "gid://shopify/ProductVariant/50760275951947" : // EU
        (this.context.psu === 1) ? "gid://shopify/ProductVariant/50760275951947" : // US
        "gid://shopify/ProductVariant/50760275951947"; // UK

      const query = `
        mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              id
              checkoutUrl
            }
            userErrors {
              field
              message
            }
          }
        }
      `;

      const variables = {
        input: {
          lines: [{ quantity: 1, merchandiseId: variantId }],
          discountCodes: ["MONOBF2025"]
        }
      };

      const response = await fetch('https://embodme-norand.myshopify.com/api/2024-04/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'c715561b4f24fbaeb3555426faa361c9'
        },
        body: JSON.stringify({ query, variables })
      });

      const data = await response.json();
      console.log('Shopify API response:', data);

      if (data.data && data.data.cartCreate && data.data.cartCreate.cart && data.data.cartCreate.cart.checkoutUrl) {
        const checkoutUrl = data.data.cartCreate.cart.checkoutUrl;
        const urlWithDiscount = checkoutUrl + (checkoutUrl.includes('?') ? '&' : '?') + 'discount=MONOBF2025';
        window.location.href = urlWithDiscount;
      } else {
        console.error('Cart creation failed:', (data.data && data.data.cartCreate && data.data.cartCreate.userErrors) || data.errors);
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error('Error creating checkout:', error);
      this.setState({ loading: false });
    }
  };
  
  render() {
    return (
      <>
        {this.state.loading && <LoadingSpinner />}
        <Navbar
          collapseOnSelect
          expand="lg"
          variant="dark"
          bg="none"
          className={`tabMonoContainer ${
            this.props.fixed ? "tabMonoFixed" : ""
          }`}
          hidden={!this.props.fixed}
        >
          <Navbar.Toggle hidden aria-controls="responsivemono-nav" />
          <Navbar.Collapse id="responsivemono-nav">
            <Nav className="me-auto">{this.items}</Nav>
          </Navbar.Collapse>
          {/* MK2 no longer sold: button disabled, checkout removed.
          <Link to={"/join-waitlist-mk2"}>
            <Nav className="rightIconPartMono">
              <button onClick={this.orderNow} className="btnOrderNowTab">
							Order Now -
                <UserContext.Consumer>
                  {context => (context.priceInEur ? "€589" : "$589")}
                </UserContext.Consumer>
                <img src={btnArrow} alt="" className="arrowButtonMonoProduct" />
              </button>
            </Nav>
          </Link> */}
          <Nav className="rightIconPartMono">
            <button className="btnOrderNowTab" disabled>
              Out of stock
            </button>
          </Nav>
        </Navbar>
      </>
    );
  }
}

export default TabMonoMK2MorphCard;
